"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.WO50 = exports.WO40 = exports.WO30 = exports.WO20 = exports.WO10 = exports.SG50 = exports.SG40 = exports.SG30 = exports.SG20 = exports.SG10 = exports.SC50 = exports.SC40 = exports.SC30 = exports.SC20 = exports.SC10 = exports.PR50 = exports.PR40 = exports.PR30 = exports.PR20 = exports.PR10 = exports.OVERLAY70 = exports.NT90 = exports.NT80 = exports.NT70 = exports.NT60 = exports.NT50 = exports.NT40 = exports.NT30 = exports.NT20 = exports.NT100 = exports.NT10 = exports.IB50 = exports.IB40 = exports.IB30 = exports.IB20 = exports.IB10 = exports.ER50 = exports.ER40 = exports.ER30 = exports.ER20 = exports.ER10 = void 0;
// PRIMARY
var PR10 = '#B2E6FA';
exports.PR10 = PR10;
var PR20 = '#66CDF6';
exports.PR20 = PR20;
var PR30 = '#00ACF0';
exports.PR30 = PR30;
var PR40 = '#008AC0';
exports.PR40 = PR40;
var PR50 = '#006790'; // SECONDARY

exports.PR50 = PR50;
var SC10 = '#CFC4DD';
exports.SC10 = SC10;
var SC20 = '#7F62A5';
exports.SC20 = SC20;
var SC30 = '#5F3B8E';
exports.SC30 = SC30;
var SC40 = '#4C2F72';
exports.SC40 = SC40;
var SC50 = '#4C2F72'; // NEUTRAL

exports.SC50 = SC50;
var NT10 = '#FFFFFF';
exports.NT10 = NT10;
var NT20 = '#F5F5F5';
exports.NT20 = NT20;
var NT30 = '#EDEDED';
exports.NT30 = NT30;
var NT40 = '#E0E0E0';
exports.NT40 = NT40;
var NT50 = '#C2C2C2';
exports.NT50 = NT50;
var NT60 = '#9E9E9E';
exports.NT60 = NT60;
var NT70 = '#757575';
exports.NT70 = NT70;
var NT80 = '#616161';
exports.NT80 = NT80;
var NT90 = '#404040';
exports.NT90 = NT90;
var NT100 = '#181818'; // SUCCESS

exports.NT100 = NT100;
var SG10 = '#C8F1E8';
exports.SG10 = SG10;
var SG20 = '#61A697';
exports.SG20 = SG20;
var SG30 = '#1E7461';
exports.SG30 = SG30;
var SG40 = '#175D4E';
exports.SG40 = SG40;
var SG50 = '#11463A'; // ERROR

exports.SG50 = SG50;
var ER10 = '#F7D8D4';
exports.ER10 = ER10;
var ER20 = '#E9948B';
exports.ER20 = ER20;
var ER30 = '#DB4D3D';
exports.ER30 = ER30;
var ER40 = '#AF3E31';
exports.ER40 = ER40;
var ER50 = '#832E25'; // WARNING

exports.ER50 = ER50;
var WO10 = '#FDE5CE';
exports.WO10 = WO10;
var WO20 = '#FABF88';
exports.WO20 = WO20;
var WO30 = '#F69539';
exports.WO30 = WO30;
var WO40 = '#C6782E';
exports.WO40 = WO40;
var WO50 = '#965B22'; // INFORMATION

exports.WO50 = WO50;
var IB10 = '#EAF0FE';
exports.IB10 = IB10;
var IB20 = '#83A7FA';
exports.IB20 = IB20;
var IB30 = '#306CF7';
exports.IB30 = IB30;
var IB40 = '#2656C6';
exports.IB40 = IB40;
var IB50 = '#132B63'; // OVERLAY

exports.IB50 = IB50;
var OVERLAY70 = 'rgba(24, 24, 24, 0.7)';
exports.OVERLAY70 = OVERLAY70;
